module.exports = __webpack_public_path__ + "static/img/title_01@3x.3c4b131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/title_01@3x.png
// module id = KnCv
// module chunks = 1